import {
  TDocuments,
  TGetDocumentsResponse,
} from '../../../../api/lendingApi/lendingApiQueries';
import { TOfferDataRequirement } from '../../../../types';

export type TDocumentRequirement = TOfferDataRequirement['actions'][number];

const REQUIREMENT_TYPE_TO_DOCUMENT_TYPE: Record<string, string> = {
  aged_debtor_report: 'aged_debtor_report',
  bank_statement: 'bank statement',
  business_plan: 'business_plan',
  company_accounts: 'business accounts',
  management_accounts: 'management_accounts',
  vat_return: 'vat return',
};

const VALID_DOCUMENT_STATUSES = ['complete', 'pending', 'under_review'];

export const isStepComplete = (
  requirement: TDocumentRequirement,
  documents: TGetDocumentsResponse | undefined,
): boolean => {
  if (!documents?.data) return false;

  const documentType = REQUIREMENT_TYPE_TO_DOCUMENT_TYPE[requirement.type];
  if (!documentType) return false;

  // For bank_statement, check if a bank account has been linked via open banking,
  // or if documents have been uploaded (indicated by `pending` status).
  // The requirement is only marked `complete` later during Document Review,
  // so for this signup step we treat `pending` as step completion.
  if (requirement.type === 'bank_statement') {
    const openBankingResolution = requirement.resolution_methods.find(
      (resolution) => resolution.type === 'link_bank_account_via_open_banking',
    );
    const hasLinkedAccount =
      openBankingResolution && openBankingResolution.items.length > 0;
    if (hasLinkedAccount || requirement.status === 'pending') {
      return true;
    }
  }

  const matchingDocuments = documents.data.filter(
    (doc: TDocuments) => doc.attributes.document_type === documentType,
  );

  return matchingDocuments.some((doc: TDocuments) =>
    VALID_DOCUMENT_STATUSES.includes(doc.attributes.status),
  );
};
